export default __webpack_public_path__ + "static/media/properties-img-banner.abbb9bf7.png";